import { ASSET_PREFIX, colors } from "utils/constants";
import Link from "next/link";
import FaqCard from 'components/FaqCard';
import GlowBar from "components/GlowBar";
import React from "react";

const SAMPLE_FAQS = [
  {
    question: "How does it work?",
    answer: <>DAYMADE Gift Cards let you gift a subscription to our Friday Weekly Draw to your friends and family. Start by selecting a Gift Card design and duration, and personalise your Gift Card with a message.<br /><br />The recipient will sign up for an account, but will not need to supply any payment details as you will have paid for their subscription up-front.<br /><br />Gift Card recipients will be treated exactly the same as our subscribers, meaning they will have the exact same chances and rights as our subscribers and will benefit from the same perks.</>
  },
  {
    question: "How does the recipient activate their Gift Card?",
    answer: "Once you have purchased a Gift Card, the recipient will receive an email with instructions for activating their subscription on our website."
  },
  {
    question: "How long are they valid for?",
    answer: "We offer 4, 12, 24, & 48 week Gift Card subscriptions."
  },
  {
    question: "Will I receive an email confirmation of my purchase?",
    answer: "Yes. The Gift Card recipient will receive an email with a link and instructions for redeeming their gift card. The Gift Card purchaser will receive a purchase confirmation email which will also have a copy of the link/instructions for redeeming the gift card (in case the Gift Card recipient didn't receive the link/instructions email)."
  },
];

const FaqSection = () => {
  return (
    <div className='container'>
      <div className='paddedMaxWidthContainer'>
        <img src={`${ASSET_PREFIX}/images/landing/question-mark.svg`} style={{ width: '28px', marginTop: '1.5em' }} />
        <h3 style={{ textShadow: `3px 3px ${colors.brand.pastel}` }}>
          A FEW <strong>FAQs</strong>
        </h3>

        { SAMPLE_FAQS.map((faq, i) =>
          <FaqCard
            key={i}
            question={faq.question}
            answer={faq.answer}
            style={{
              margin: '0.75em 0'
            }}
          />
        )}

        <Link href='/faq'>
          <a className='seeMoreButton'>SEE <strong>MORE</strong> →</a>
        </Link>
      </div>

      <GlowBar color='#DDD' direction='up' />

      <style jsx>{`
        .container {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          background: white;
        }
        
        .seeMoreButton {
          font-size: 1.5em;
          font-weight: bold;
          cursor: pointer;
          color: ${colors.primaryBrandGray};
          margin: 2em;
        }
      `}</style>
    </div>
  );
};

export default FaqSection;
